import Api from '@/services/api';
import {removeEmptyParams, transformDownloadResponse} from '@utils';
import contentDisposition from 'content-disposition';

export default {
  partenaires(filter) {
    return Api()
      .get('/partenaires', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  autocomplete(filter) {
    return Api()
      .get('/partenaires/autocomplete', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  partenairesForAutocomplete(filter) {
    return Api()
      .get('/partenaires/autocomplete', {params: removeEmptyParams(filter)})
      .then((res) => this.formatRes(res.data));
  },
  partenaire(partenaireId) {
    return Api()
      .get('/partenaire/' + partenaireId)
      .then((res) => this.formatRes(res.data));
  },
  partenaireDisplay(partenaireId) {
    return Api()
      .get('/partenaire/' + partenaireId + '/display')
      .then((res) => this.formatRes(res.data));
  },
  enable(partenaire) {
    return Api()
      .get('/partenaire/enable/' + partenaire.id)
      .then((res) => this.formatRes(res.data));
  },
  disable(partenaire) {
    return Api()
      .get('/partenaire/disable/' + partenaire.id)
      .then((res) => this.formatRes(res.data));
  },
  exportList(filter) {
    return Api()
      .get('/partenaires/export', {
        responseType: 'blob',
        transformResponse: [transformDownloadResponse],
        params: removeEmptyParams(filter),
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let fileName = contentDisposition.parse(response.headers['content-disposition']).parameters.filename;
        link.setAttribute('download', fileName);
        link.click();
        window.URL.revokeObjectURL(url);
      });
  },
  create(partenaire) {
    return Api()
      .post('/partenaire', partenaire)
      .then((res) => this.formatRes(res.data));
  },
  access(partenaire) {
    return Api()
      .post('/partenaire/' + partenaire.id + '/access')
      .then((res) => this.formatRes(res.data));
  },
  update(partenaire) {
    return Api()
      .put('/partenaire/' + partenaire.id, partenaire)
      .then((res) => this.formatRes(res.data));
  },
  updateEmail(employeeId, email) {
    return Api().put('/partenaire/' + employeeId + '/email', {email: email});
  },
  delete(partenaire) {
    return Api()
      .delete('/partenaire/' + partenaire.id)
      .then(() => partenaire);
  },
  formatRes(e) {
    return e;
  },
};
